import { FILE_UPLOAD } from "./ApiRoutes";
import { authData } from "./services";

export const upload_image = async (formData: FormData) => {
    const response = await authData.post(FILE_UPLOAD, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response?.data;
};